export default "__VITE_ASSET__447ccd5a__"